<template>
  <iframe
    src="https://socialchat.tubtimcrm.com"
    class="w-100"
    frameborder="0"
  />
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
iframe {
  /* Adjust height based on your app's header/nav height */
  height: calc(100vh - 10rem);
}
</style>
